import {DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST} from "@constants/dropdown-choices";
import {validateCommonPolicyHolderClaims} from "@validators/common/sub-components/validate-common-policy-holder-claims";
import {
   validateCommonPolicyHolderConvictions
} from "@validators/common/sub-components/validate-common-policy-holder-convictions";


export const ValidateStep4Data = (data) => {

    const msgList = [];

    validateCommonPolicyHolderClaims({
       data,
       msgList
    })
   
   validateCommonPolicyHolderConvictions({
      data,
      msgList
   })
    
    return msgList;

}